import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=34422ea6&scoped=true&"
import script from "./Journalism.vue?vue&type=script&lang=js&"
export * from "./Journalism.vue?vue&type=script&lang=js&"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=34422ea6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34422ea6",
  null
  
)

export default component.exports